import { DictionaryEvidence, TableColumn } from '@eas/common-web';
import { AbsenceType } from '@models';

export function useColumns(): TableColumn<AbsenceType>[] {
  const dictionaryColumns =
    DictionaryEvidence.useDictionaryColumns<AbsenceType>();

  return [dictionaryColumns.columnName];
}
